export default __webpack_public_path__ + "static/media/c002-PPII-15.7406968e.svg";